import type { components } from '@pba/types-openapi-client';
import { parseISO } from 'date-fns';
import type { UploadedFile } from './uploaded-file';
import { createUploadedFile } from './uploaded-file';
import type { UserList } from './user';
import { createUserList } from './user';

export type Reply = BaseReply | ExtendedReply;

type BaseReply = {
  attachments: UploadedFile[];
  author: UserList;
  bookmarked: boolean;
  createdAt: Date;
  htmlContent: string;
  id: string;
  liked: boolean;
  likesCount: number;
  parentId: string;
  replies?: Reply[];
  textContent: string;
  type: string;
};

type ExtendedReply = {
  topParentId: string;
  topParentShareableId: string;
  // This is enum
  topParentType: string;
} & BaseReply;

export const createReplyData = (data: components['schemas']['Comment']): Reply => {
  if ('top_parent_id' in data) {
    return createExtendedReplyData(data);
  }

  return createBaseReplyData(data);
};

const createBaseReplyData = (data: components['schemas']['Comment']): BaseReply => ({
  attachments: data.attachments.map((attachment) => createUploadedFile(attachment)),
  author: createUserList(data.author),
  bookmarked: data.bookmarked,
  createdAt: parseISO(data.created_at),
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  htmlContent: data.html_content ?? '',
  id: data.id,
  liked: data.liked,
  likesCount: data.likes_count,
  parentId: data.parent_id,
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  replies: data.replies?.map((reply) => createReplyData(reply)),
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  textContent: data.text_content ?? '',
  type: data.type,
});

const createExtendedReplyData = (data: components['schemas']['Comment']): ExtendedReply => ({
  ...createBaseReplyData(data),
  topParentId: data.top_parent_id,
  topParentShareableId: data.top_parent_shareable_id,
  topParentType: data.top_parent_type,
});
